import * as React from 'react';
import { Icon, Button } from 'antd';

import styles from './quantity-button.module.scss';

export interface Props {
    iconType: string;
    disabled?: boolean;
    onClick: () => void;
}

interface State {
    invertIcon: boolean;
}

class QuantityButton extends React.Component<Props> {
    public readonly state: State = {
        invertIcon: false,
    };

    public componentDidUpdate(prevProps: Readonly<Props>): void {
        const { disabled: prevDisabled } = prevProps;

        const { disabled } = this.props;

        if (prevDisabled !== disabled && disabled) {
            this.handleDisableInvertIcon();
        }
    }

    public render(): React.ReactNode {
        const { iconType, disabled, onClick } = this.props;

        const { invertIcon } = this.state;

        const iconTheme = invertIcon && !disabled ? 'filled' : 'outlined';

        return (
            <Button
                className={styles.button}
                shape="circle"
                disabled={disabled}
                onClick={onClick}
                onFocus={this.handleEnableInvertIcon}
                onBlur={this.handleDisableInvertIcon}
            >
                <Icon type={iconType} className={styles.icon} theme={iconTheme} />
            </Button>
        );
    }

    private handleEnableInvertIcon = (): void => {
        this.setState({
            invertIcon: true,
        });
    };

    private handleDisableInvertIcon = (): void => {
        this.setState({
            invertIcon: false,
        });
    };
}

export { QuantityButton };
